import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { dedupedRequest } from '../utils/axios';
import { useSearchParams } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const PasswordReset = () => {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const reset_token = useMemo(() => sp.get("token") ?? "", [sp]);

  const [new_password, setNewPassword] = useState('');
  const [new_password_repeat, setNewPasswordRepeat] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return; // Prevent multiple submissions
    setLoading(true);
    setError('');
    setMessage('');
    if (new_password !== new_password_repeat) {
      setError('Die neuen Passwörter stimmen nicht überein.');
      setLoading(false);
      return;
    }
    try {
      const res = await dedupedRequest<{ access_token: string }>(
        {
          method: 'POST',
          url: '/password/reset',           // baseURL '/api' is applied in axios.ts
          data: { reset_token, new_password },
          withCredentials: true,   // ensure refresh cookie is set on successful login
          headers: { 'Content-Type': 'application/json' },
        },
        { useCache: false, maxRetries: 0 } // no caching; avoid retries on bad creds
      );
      const status = res.status;
      if (status !== 204) {
        throw new Error('Passwortänderung fehlgeschlagen.');
      } else {
        setMessage('Passwort erfolgreich geändert. Sie werden weitergeleitet zum Login.');
        // Optionally, auto-redirect to login after a short delay
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (err: any) {
      // Axios errors often have response.data with details
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        err?.message ||
        'Login failed';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md="auto">

          <form onSubmit={handleSubmit}>
            <Card style={{ width: '24rem' }}>
              <Card.Body>
                <Card.Title><h2>Neues Passwort</h2></Card.Title>
                  <div data-mdb-input-init className="form-outline mb-2">
                    <input
                      className='form-control'
                      id="NewPasswordInput1"
                      type="password"
                      value={new_password}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Neues Passwort"
                      required
                    />
                  </div>
                  <div data-mdb-input-init className="form-outline mb-2">
                    <input
                      className='form-control'
                      id="NewPasswordInput2"
                      type="password"
                      value={new_password_repeat}
                      onChange={(e) => setNewPasswordRepeat(e.target.value)}
                      placeholder="Neues Passwort wiederholen"
                      required
                    />
                  </div>
                  <button type="submit" data-mdb-button-init data-mdb-ripple-init className="btn btn-primary btn-block mb-4">Abschicken</button>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                {message && <p style={{ color: 'green' }}>{message}</p>}
              </Card.Body>
            </Card>

          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordReset;
